import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';
import { MuiAvatar } from './avatar';
import { MuiButton } from './button';
import { MuiCard } from './card';
import { MuiCardContent } from './card-content';
import { MuiCardHeader } from './card-header';
import { MuiCardActions } from './card-actions';
import { MuiLink } from './link';
import { MuiStack } from './stack';
import { MuiTab } from './tab';
import { MuiTableBody } from './table-body';
import { MuiTableCell } from './table-cell';
import { MuiTableHead } from './table-head';
import { MuiTextField } from './text-field';
import { MuiSelect } from './select';
import { MuiCheckbox } from './checkbox';
import { MuiContainer } from './container';
import { MuiCssBaseline } from './css-baseline';
import { MuiListItemButton } from './list-item-button';
import { MuiAppBar } from './app-bar';
import { MuiAutocomplete } from './auto-complete';

export const components = {
    MuiAppBar,
    MuiAutocomplete,
    MuiAvatar,
    MuiCssBaseline,
    MuiButton,
    MuiCard,
    MuiCardContent,
    MuiCardHeader,
    MuiCardActions,
    MuiCheckbox,
    MuiContainer,
    MuiLink,
    MuiListItemButton,
    MuiSelect,
    MuiStack,
    MuiTab,
    MuiTableBody,
    MuiTableCell,
    MuiTableHead,
    MuiTextField,
} satisfies Components<Theme>;
